import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Header from './Header';

const minHeight = 'calc(100vh - 165px)';

const useStyles = makeStyles((theme: any) => ({
  timelineColumn: {
    borderRadius: '8px 10px 8px 10px',
    gridRow: ({ numOfLinesToShow }: any) => {
      return `1/${numOfLinesToShow + 1}`;
    },
    gridColumn: ({ column }: any) => {
      return column;
    },
    height: ({ numOfLinesToShow }) => {
      if (numOfLinesToShow < 2) {
        return minHeight;
      } else {
        return `calc(100% + ${theme.spacing(1)}px)`;
      }
    },
    minWidth: 85,
    marginTop: theme.spacing(5),
  },
  color: {
    marginLeft: theme.spacing(0.75),
    marginRight: theme.spacing(0.75),
    backgroundColor: theme.palette.brand.blueGreyLight,
    height: '100%',
    borderRadius: '8px 10px 8px 10px',
    minHeight: minHeight,
  },
}));

export default function TimelineColumn({
  column,
  numOfLinesToShow = 12,
  header,
}) {
  const classes = useStyles({
    column,
    numOfLinesToShow,
  });

  return (
    <div className={classes.timelineColumn}>
      <Header header={header} column={column} />
      <div className={classes.color} />
    </div>
  );
}
